<template>
    <div class="box" @click="openRouteItinerary">
        <div class="start-marker top-left">
            <div></div>
        </div>
        <div class="end-marker bottom-left">
            <div></div>
        </div>
        <div class="pickup">{{routeData.pickup}}</div>
        <div class="destination">{{routeData.destination}}</div>
        <div class="route-code">{{routeData.route_code}}</div>
    </div>
</template>
<script>
export default{
    data(){
      return {
        showItinerary: false
      }
    },
    props:{
        routeData: Object
    },
    methods: {
      openRouteItinerary() {
        this.showItinerary = true;
        this.$emit("show-itinerary", this.routeData);
      }
    }
}
</script>
<style scoped>
    .pickup, .destination{
        font-size: 10.5px;
    }
    .pickup{
        margin-bottom: 5px;
    }
    .destination{
        margin-bottom: 10px;
    }
    .route-code{
        font-size: 10.5px;
        margin-top: 5px;
        color: #7596c4c2;
    }
    .box{
        padding: 0px 20px;
        min-height: 60px;
        width: 200px;
        border-left: 2px solid #7596c4c2;
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .start-marker{
        border-radius: 50%;
        width: 10px;
        height: 10px;
        background-color: #65c87a;
        position: relative;
    }
    .start-marker > div{
        border-radius: 50%;
        width: 30%;
        height: 30%;
        background-color: white;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
    }
    .end-marker{
        border-top-left-radius: 50%;
        border-top-right-radius: 50%;
        border-bottom-left-radius: 50%;
        transform: translate(calc(-50% - 1px), calc(50%)) rotate(45deg) !important;
        width: 10px;
        height: 10px;
        background-color: #0698ff;
        position: relative;
    }
    .end-marker > div{
        border-radius: 50%;
        width: 30%;
        height: 30%;
        background-color: white;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
    }
    .bottom-left{
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translate(calc(-50% - 1px), calc(50% + 2px));
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(calc(-50% - 1px), calc(-50% - 2px));
    }
</style>